export const billingFrequencies = [
  "Monthly",
  "Quarterly",
  "Annually",
  "One Time",
];
